import './allergology/register';
import './bariPost/register';
import './bariPre/register';
import './cardiology/register';
import './echography/register';
import './hearingLoss/register';
import './neurology/register';
import './osas/register';
import './tpcFlex/register';
import './tpoFlex/register';
